/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Yearly long-term retention policy.
 */
export interface BackupServerBackupJobGFSPolicySettingsYearly { 
    /**
     * Indicates whether the yearly GFS retention policy is enabled.
     */
    isEnabled: boolean;
    /**
     * Number of years during which restore points must be stored.
     */
    keepForNumberOfYears?: number | null;
    /**
     * Month when the yearly restore point must be created.
     */
    desiredTime?: BackupServerBackupJobGFSPolicySettingsYearlyDesiredTime | null;
}
export enum BackupServerBackupJobGFSPolicySettingsYearlyDesiredTime {
    Jan = 'Jan',
    Feb = 'Feb',
    Mar = 'Mar',
    Apr = 'Apr',
    May = 'May',
    Jun = 'Jun',
    Jul = 'Jul',
    Aug = 'Aug',
    Sep = 'Sep',
    Oct = 'Oct',
    Nov = 'Nov',
    Dec = 'Dec'
};



